export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const validatePassword = (password: string) => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return passwordRegex.test(password);
}

export interface ImprovementData {
  currentValue: number;
  previousValue: number;
  absoluteChange: number;
  percentageChange: number;
  isPositive: boolean;
}

export const calculateImprovement = (currentValue: number, previousValue: number): ImprovementData => {
  const absoluteChange = currentValue - previousValue;
  const percentageChange = previousValue > 0
    ? Number(((absoluteChange / previousValue) * 100).toFixed(1))
    : 0;
  const isPositive = absoluteChange >= 0;

  return {
    currentValue,
    previousValue,
    absoluteChange,
    percentageChange,
    isPositive
  };
};

export interface DataPoint {
  index: number;
  value: number;
}

export const calculateImprovementFromData = (data: DataPoint[]): ImprovementData | null => {
  if (data.length < 2) return null;

  const currentValue = data[data.length - 1].value;
  const previousValue = data[data.length - 2].value;

  return calculateImprovement(currentValue, previousValue);
};
